import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import { CountdownTimer } from 'src/components/Chicken/ui/countdown-timer/CountdownTimer'
import common from 'src/styles/common.module.scss'
import styles from './styles.module.scss'

export const TextHeaderFr = () => {
    const isDesktop = useMediaQuery('(min-width: 1024px)')

    return (
        <div className={styles.wrapper_content}>
            <HighlightedText
                text="Devinez où se trouve l'argent."
                highlights={[
                    { word: 'Devinez' },
                    { word: 'où' },
                    { word: 'se' },
                    { word: 'trouve' },
                    { word: "l'argent." },
                ]}
                breakAfterWords={isDesktop ? [] : ['se']}
                className={common.text_header}
            />
            <div className={styles.wrapper}>
                <span className={styles.text}>Trois essais!</span>
                <CountdownTimer />
            </div>
        </div>
    )
}
